module.exports = __webpack_public_path__ + "img/16d001-06.498307df.jpg";